import styled from '@emotion/styled'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { joinClasses } from './joinClasses'

type ExtranetTableProps = PropsWithChildren & HTMLAttributes<HTMLDivElement>

const delayStyles = () => {
  const styles = {} as any

  for (let i = 0; i < 30; i++) {
    styles['&:nth-of-type(' + i + ')'] = {
      animationDelay: `${i * 0.03}s`,
    }
  }

  return styles
}

const ExtranetTableRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > div.entable__row:not(:first-of-type) {
    @keyframes reveal {
      0% {
        opacity: 0.1;
      }
      100% {
        opacity: 1;
      }
    }

    transition: var(--transition-cubic-bezier);
    animation: reveal 0.5s;
    animation-fill-mode: backwards;
    animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

    ${delayStyles}
  }
`

export const ExtranetTable = ({ children, ...props }: ExtranetTableProps) => {
  return (
    <ExtranetTableRoot
      {...props}
      className={joinClasses('entable', props.className)}
    >
      {children}
    </ExtranetTableRoot>
  )
}
